module.exports = {
	name: 'json',
	validation(yup) {
		return yup.object();
	}
};
